import React from 'react'
import CollectionProduct from '../../Components/CollectionProduct/CollectionComponent'

const CollectionPage = () => {
  return (
    <div>        
        <CollectionProduct/>
    </div>
  )
}

export default CollectionPage